import Dropzone from 'dropzone';

$.validator.addMethod( "spb_phone", function( value, element ) {
    return this.optional( element ) || $(element).inputmask("isComplete");
  }, "Введите правильный телефон" );

$.validator.addMethod("eitherEmail", function(value, element) {
    let email = this.optional(element) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(value);
    return email;
}, "Введите правильный email");

$(function () {
//validate form
	let formValidate = $('.js-form'),
		url = formValidate.attr('action');

	formValidate.each(function () {
		let thisForm = $(this);
		let fileArr = [];

		if (thisForm.find('.js-dropzone')[0]) {

			Dropzone.autoDiscover = false;
			var myDropzone = new Dropzone(thisForm.find('.js-dropzone')[0], {
				url: thisForm.attr('action'),
				paramName: 'file[]',
				maxFilesize: 4,
				uploadMultiple: true,
				addRemoveLinks: true,
				acceptedFiles: ".png,.jpg,.jpeg",
				dictRemoveFile: 'Удалить',
				init: function () {
					this.on("maxfilesexceeded", function (file) {
						this.removeFile(file)
					});
					this.on("addedfile", function (file) {
						if ((file.type != 'image/png') && (file.type != 'image/jpeg')) {
							this.removeFile(file)
						} else {
							fileArr.push(file);
						}
					})
				}
			});
		}

		thisForm.validate({
			rules: {
				tel: {
				        required: true,
				        spb_phone: true
				    },
				phone: {
				        required: true,
				        spb_phone: true
				    },
				email: {
					eitherEmail: true
				}
			},
			highlight: function (element) {
				$(element).closest(".input-wrap").addClass('is-error');
			},
			unhighlight: function (element) {
				$(element).closest(".input-wrap").removeClass('is-error');
			},
			submitHandler: function (form, event) {
				event.preventDefault();

				var formId = thisForm.attr('id');
				var beforeSendFunction = formId + '_beforeSendFunction';
				var calculateFunction = formId + '_calculateFunction';

				var calculatedField = thisForm.find('.__calculatedField');

				if (calculatedField.length) {
					if (typeof window[calculateFunction] !== 'undefined') {
						calculatedField.val(window[calculateFunction](thisForm[0]));
					}
				}

				var data = new FormData(),
					formParams = thisForm.serializeArray();

				$.each(fileArr, function (i, file) {
					data.append('file[]', file);
				});

				$.each(formParams, function (i, val) {
					data.append(val.name, val.value);
				});

				data.append('key', 'value');

				/* ******* */
				$.ajax({
					url: thisForm[0].action,
					type: 'POST',
					processData: false,
					contentType: false,
					data: data,
					beforeSend: function (data) {
						thisForm.find('button').attr('disabled', 'disabled');

						if (typeof window[beforeSendFunction] !== 'undefined') {
							window[beforeSendFunction](thisForm[0]);
						}
					},
					success: function (data) {
						if (data['error']) {
							console.log('error');
						} else {
							setTimeout(function () {
								thisForm.find('button').prop('disabled', false);
								thisForm[0].reset();

								if (myDropzone) {
									myDropzone.removeAllFiles();
								}

								$('.popup').removeClass('popup-show');
								$('#popup-thanks').addClass('popup-show');
								$('.popup').removeClass('popup-show');
								$('#popup-thanks').addClass('popup-show');

								thisForm[0].reset();

								let $select2 = $('.js-select');
								if ($select2.length) {
									$select2.each(function () {
										$(this).val('').trigger('change');
										;
									})
								}

								let $formRecord = $('.record-form');
								if ($formRecord.length) {
									$formRecord.hide();
								}
							}, 500);
						}
					},
					error: function (xhr, ajaxOptions, thrownError) {
						console.log(xhr.status);
						console.log(thrownError);
					}
				});
				return false;
			}
		});

	});

	$('.js-close-thank').on('click', function () {
		$('.popup').removeClass('is-show');
		$('#popup-thank').removeClass('active');
	});

	$('.js-select').on('change', function(){
		$(this).closest('.input-wrap').removeClass('is-error');
		$(this).closest('.input-wrap').find('label.error').hide();
	})

});

